




























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "datav/playrecord";

  columns: any[] = [
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", dataIndex: "username" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "打球时间", dataIndex: "created_time" }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId,
        item: "player"
      },
      false
    );
  }
}
